/* eslint-disable eag/match-named-export */
import {ThunkDispatch} from '@reduxjs/toolkit';
import {RootState} from '@reduxjs/toolkit/query';

import {UnknownAction} from 'redux';

import {
  CreateUserVehicleSummaryRequestBody,
  ListUserResponseBody,
  SourcingVehicleListResponseBody,
} from '../types';

export type OmneticMutationLifecycleApi<_T> = {
  dispatch: ThunkDispatch<any, any, UnknownAction>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  getState: () => RootState<any, any, 'rtk_omneticApi'>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  queryFulfilled: Promise<any>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
};

export type List =
  | 'favourite'
  | 'comparison'
  | 'inCart'
  | 'hidden'
  | 'seen'
  | 'isNew'
  | 'carvagoBuy';

export function isSourcingListEndpointName(
  endpointName: string
): endpointName is 'sourcingVehicleList' {
  return endpointName === 'sourcingVehicleList';
}

export function setUserVehicleSummary(
  vehicleId: string,
  body: CreateUserVehicleSummaryRequestBody,
  response: SourcingVehicleListResponseBody | ListUserResponseBody
) {
  response.data.forEach((vehicle) => {
    if (vehicle.sourcingVehicle.adId === vehicleId) {
      vehicle.vehicleSummary = {
        ...vehicle.vehicleSummary,
        comment: body.comment ?? null,
        purchasePrice: body.purchasePrice ?? null,
        sellingPrice: body.sellingPrice ?? null,
      };
    }
  });
}
